function normalizePath(path) {
  const value = String(path || '/').trim();

  if (!value || value === '/') {
    return '/';
  }

  const withLeadingSlash = value.startsWith('/') ? value : `/${value}`;
  const withoutQuery = withLeadingSlash.split('?')[0].split('#')[0];
  const collapsedSlashes = withoutQuery.replace(/\/+/g, '/');
  const normalized =
    collapsedSlashes.length > 1 ? collapsedSlashes.replace(/\/+$/, '') : collapsedSlashes;

  return normalized || '/';
}

function getCurrentPath() {
  return normalizePath(window.location.pathname || '/');
}

function navigate(path) {
  const nextPath = normalizePath(path);

  if (normalizePath(window.location.pathname) !== nextPath) {
    window.history.pushState({}, '', nextPath);
    window.dispatchEvent(new PopStateEvent('popstate'));
  }
}

export { getCurrentPath, navigate };